// Central registry for AI plugin instances.
// Import this module instead of reading from window.* to get typed, stable references.
//
// Window globals that the inline HTML onclick handlers inside aiAssistantPanel require
// (e.g. onclick="closeAIAssistant()") are still set, but they're set here once rather
// than scattered across pluginManager.ts.

interface AIContextEnhancer {
  generateAIContext: (options?: object) => object;
  generateContextAwarePrompt: (prompt: string, context?: object) => string;
  suggestComponents: (context?: object) => object[];
  componentRegistry: Record<string, object>;
  availableTools: Record<string, object>;
  [key: string]: unknown;
}

interface AIAssistantPanelInstance {
  showPanel: () => void;
  closePanel?: () => void;
  [key: string]: unknown;
}

interface GptPanelInstance {
  show: () => void;
  close: () => void;
}

const state: {
  contextEnhancer: AIContextEnhancer | null;
  assistantPanel: AIAssistantPanelInstance | null;
  gptPanel: GptPanelInstance | null;
} = {
  contextEnhancer: null,
  assistantPanel: null,
  gptPanel: null,
};

export function registerContextEnhancer(enhancer: AIContextEnhancer): void {
  state.contextEnhancer = enhancer;

  // Expose the function the GPT plugin looks up by name
  (window as any).generateContextAwarePrompt = enhancer.generateContextAwarePrompt.bind(enhancer);

  // Expose the context object the assistant panel reads for component counts
  (window as any).aiContext = enhancer.generateAIContext();
}

export function registerAssistantPanel(panel: AIAssistantPanelInstance): void {
  state.assistantPanel = panel;
}

export function getContextEnhancer(): AIContextEnhancer | null {
  return state.contextEnhancer;
}

export function getAssistantPanel(): AIAssistantPanelInstance | null {
  return state.assistantPanel;
}

export function registerGptPanel(panel: GptPanelInstance): void {
  state.gptPanel = panel;
  (window as any).showGptPanel = panel.show;
  (window as any).closeGptPanel = panel.close;
}

export function getGptPanel(): GptPanelInstance | null {
  return state.gptPanel;
}
